export default __webpack_public_path__ + "static/media/hell_skull.7fdb9ec7.png";